import type { ActionIdRegistry, Optional, Server } from '@festina-life/core'
import type { CommandActionVariantOrSimulation } from '@festina-life/ui/theme'

import type { VariantIdentifier } from '../../context/scenarioContext'
import { useComponent } from '../../lenteHooks'

export const useScenarioCondition = ({
  actionId,
  commandActionVariant,
  variantIdentifier,
  festinaComponent,
}: {
  actionId: keyof ActionIdRegistry
  commandActionVariant: CommandActionVariantOrSimulation
  variantIdentifier?: Optional<VariantIdentifier>
  festinaComponent: Server
}) => {
  const collectionCommitmentActionButtons = useComponent(
    'pages.commandDataActions.life.collectionCommitmentActionButtons',
  )
  const collectionPersonPretendCommandPaletteButtons = useComponent(
    'pages.commandDataActions.life.collectionPersonPretendCommandPaletteButtons',
  )

  const commandType = actionId.split('.').at(1) ?? ''

  const isPretendCommand =
    commandType in collectionPersonPretendCommandPaletteButtons

  const isPretendCommandWithoutVariant =
    isPretendCommand && !variantIdentifier && commandActionVariant === 'create' // create actionVariant condition enables to use the read mode when coping a scenario variant without the scenario manager modal opening

  const shouldShowScenariosButton =
    (commandType in collectionCommitmentActionButtons || isPretendCommand) &&
    festinaComponent === 'life' &&
    commandActionVariant === 'create'

  return {
    isPretendCommandWithoutVariant,
    shouldShowScenariosButton,
  }
}
